import React from "react";
import { Icon } from "@iconify/react";
import Loader from "../../../components/Loader";
import { BarChartByYear } from "../../../components/charts/rechart/BarChartByYear";
import { useTranslation } from "react-i18next";


const ProfessionalDashboard = () => {
    const { t } = useTranslation();
  
  const cardArray = [
    {
      icon: <Icon icon="icon-park-outline:list" className="currency-icon p-2" fontSize={60} color="#EB8153" />,
      value: 500,
      title: t("hbusinessTotal"),
    },
    {
      icon: <Icon icon="dashicons:welcome-view-site" className="currency-icon p-2" fontSize={60} color="#EB8153" />,
      value: 500,
      title: t("htotalads"),
    },
    {
      icon: <Icon icon="bxs:report" className="currency-icon p-2" fontSize={60} color="#EB8153" />,
      value: 500,
      title: t("hsellerRate"),
    },
    {
      icon: <Icon icon="carbon:review" className="currency-icon p-2" fontSize={60} color="#EB8153" />,
      value: 500,
      title: t("htotalreviews"),
    },
  ];
  return (
    <div>
      {/* {loading && <Loader forProcess={true} />} */}
      <h2 className="mb-5">{t("sidebarItemDashboard")}</h2>

      {/* cards */}
      <div className="row">
        {cardArray?.map((item, index) => (
          <div className="col-xl-3 col-sm-6 px-2" key={index}>
            <div className="card card-coin ">
              <div className="card-body text-center">
                {item?.icon}
                <h2 className="text-black mb-2 font-w600">{item?.value}</h2>
                <p className="mb-0 fs-14">
                  {/* <span className="text-success me-1">45%</span> */}
                  {item?.title}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="card card-coin px-5 py-3">
        <h3 className="mb-4">{t("hearning")}</h3>
        <div className="">
          <BarChartByYear
            data={[
              { name: "Jan", totalnumberofearning: 500 },
              { name: "Feb", totalnumberofearning: 600 },
              { name: "Mar", totalnumberofearning: 550 },
              { name: t("hapril"), totalnumberofearning: 650 },
              { name: t("hmay"), totalnumberofearning: 700 },
              { name: "Jun", totalnumberofearning: 720 },
              { name: "Jul", totalnumberofearning: 680 },
              { name: t("haug"), totalnumberofearning: 750 },
              { name: "Sep", totalnumberofearning: 800 },
              { name: "Oct", totalnumberofearning: 820 },
              { name: "Nov", totalnumberofearning: 850 },
              { name: "Dec", totalnumberofearning: 900 },
            ]}
            color="#10439F"
          />
        </div>
      </div>
    </div>
  );
};

export default ProfessionalDashboard;
